import { Box, Typography } from "@mui/material";
import { STATUS_BADGE_COLORS } from "../../Admissions/AdmissionStatusBadge";
import { formatCount } from "./summaryConstants";

const chipClass = (status) => STATUS_BADGE_COLORS[status] || "bg-app-surface-muted text-app-text";

const StatusBreakdown = ({ breakdown, emptyText = "No admissions recorded yet." }) => {
  const entries = Object.entries(breakdown || {});
  if (!entries.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        {emptyText}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {entries.map(([status, count]) => (
        <span
          key={status}
          className={`px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${chipClass(
            status
          )}`}
        >
          {status}: {formatCount(count)}
        </span>
      ))}
    </Box>
  );
};

export default StatusBreakdown;
